var map = {
	"./heroicon-announcement.svg": [
		"dbf3",
		"chunk-2d229281"
	],
	"./heroicon-clipboard.svg": [
		"a22c",
		"chunk-2d207b18"
	],
	"./heroicon-cloud-upload.svg": [
		"edef",
		"chunk-2d230e76"
	],
	"./heroicon-document-check.svg": [
		"51fc",
		"chunk-2d0c7d4f"
	],
	"./heroicon-envelope-closed.svg": [
		"8ac5",
		"chunk-2d0e8e11"
	],
	"./heroicon-hand-open.svg": [
		"06e2",
		"chunk-2d0a49e9"
	],
	"./heroicon-identification.svg": [
		"42c9",
		"chunk-2d0c0c2a"
	],
	"./heroicon-lock.svg": [
		"28d5",
		"chunk-2d0b3a0d"
	],
	"./heroicon-shield-check.svg": [
		"1653",
		"chunk-2d0ab879"
	],
	"./heroicon-thumbs-up.svg": [
		"df63",
		"chunk-2d229bb5"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7b84";
module.exports = webpackAsyncContext;